import { useEffect } from 'react';
import Layout from '../components/Modular/Layout';
import Section from '../components/Modular/Section';
import Unit from '../components/Modular/Unit';
import { Card } from '../components/Card';
import Button from '../components/Button';
import { useQuery } from '../hooks/useQuery';
import { AthenaCore } from 'athena-core';

export const PaymentStatusPage = () => {
  const query = useQuery();

  const status = query.get('status');
  const consultationId = query.get('consultationId');

  const context = {
    section: {
      layout: 'grid',
      background: 'bg-dark',
      justifyItems: 'center',
    },
    unit: {
      colSpan: '1',
      rowSpan: '1',
    },
  };

  const handleNext = () => {
    AthenaCore.redirect('/');
  };

  const success = status === 'success';
  const failure = status === 'failure';

  console.log(status, success, failure, consultationId);

  useEffect(() => {
    if (!success && !failure) {
      AthenaCore.redirect('/');
    }
  }, [status]);

  return (
    <Layout
      layout="grid"
      gap="md"
      alignContent="center"
      justifyItems="center"
      background="dark"
      context={context}
    >
      <Section layout="grid" background="dark">
        <Card
          title={success ? 'Payment Successful' : 'Payment Failed'}
          subtitle={
            success
              ? 'Thank you for your payment. Your consultation is confirmed.'
              : 'Your payment was not successful. Please try again.'
          }
          className=""
          context=""
          footer={null}
        >
          {success && (
            <>
              <p>
                You will receive a confirmation email shortly with your
                consultation details.
              </p>
              <p>Consultation ID: {consultationId || 'Unavailable'}</p>
            </>
          )}

          {failure && (
            <p>
              Please check your payment details or try again later. Contact
              support if the issue persists.
            </p>
          )}

          <Button onClick={handleNext} variant="outline" className="mt-4">
            Return to Home
          </Button>
        </Card>
      </Section>
    </Layout>
  );
};
